<template>
  <div class="card">
    <div class="card-body p-3">
      <div class="form-check">
        <input
          v-model="acceptTerms"
          class="form-check-input"
          type="checkbox"
          id="acceptTerms"
          required
        />
        <label class="form-check-label" for="acceptTerms">
          Ich habe die <a href="/legal/terms" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere sie.
        </label>
      </div>
      
      <div class="form-check mt-2">
        <input
          v-model="acceptPrivacy"
          class="form-check-input"
          type="checkbox"
          id="acceptPrivacy"
          required
        />
        <label class="form-check-label" for="acceptPrivacy">
          Ich habe die <a href="/legal/privacy" target="_blank">Datenschutzerklärung</a> gelesen und akzeptiere sie.
        </label>
      </div>

      <div class="form-check mt-2">
        <input
          v-model="acceptWiderruf"
          class="form-check-input"
          type="checkbox"
          id="acceptWiderruf"
          required
        />
        <label class="form-check-label" for="acceptWiderruf">
          Ich bestätige, dass ich auf das <a href="/legal/widerruf" target="_blank">Widerrufsrecht</a> verzichte, da die Dienstleistung sofort nach dem Kauf erbracht wird.
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const emit = defineEmits(['terms-changed'])

const acceptTerms = ref(false)
const acceptPrivacy = ref(false)
const acceptWiderruf = ref(false)

const allTermsAccepted = computed(() => {
  return acceptTerms.value && acceptPrivacy.value && acceptWiderruf.value
})

watch([acceptTerms, acceptPrivacy, acceptWiderruf], () => {
  emit('terms-changed', allTermsAccepted.value)
})
</script>
